module.exports = __webpack_public_path__ + "b37604b8caeb3c63aab223c1d03b3a60.svg";